import { useSelector } from 'react-redux';
import { selectCompanyLogo } from '../../Redux/slices/authSlice';
import logoIcon from '../../assets/images/users/cropped-authx-logos.png';

export default function LogoIcon() {
  const companyLogo = useSelector(selectCompanyLogo);
  return <img src={companyLogo || logoIcon} alt="Company logo" style={{ height: 34, width: 34, objectFit: 'contain', display: 'block' }} />;
}
